import { Collapse } from 'antd';
import { RATE_BASIS_LABELS } from '../../../../../shared/policies/rate-basis-labels';
import { groupLinesByLane } from '../policies/group-lines-by-lane';
import { PriceVersionsTable } from './PriceVersionsTable';
import type { RateLineView } from '../../../rate-cards.api';

interface LaneListProps {
  lines: RateLineView[];
  today: string;
  canEdit: boolean;
  onChangePrice: (line: RateLineView) => void;
  onShowHistory: (line: RateLineView) => void;
}

/** This page of lines, grouped by lane (origin → destination), each lane open so every price is in view. Lane labels are zone codes, as the API returns them. */
export function LaneList({ lines, today, canEdit, onChangePrice, onShowHistory }: LaneListProps) {
  const lanes = groupLinesByLane(lines);

  return (
    <Collapse
      key={lanes.map((lane) => lane.lane).join()}
      defaultActiveKey={lanes.map((lane) => lane.lane)}
      items={lanes.map((lane) => ({
        key: lane.lane,
        label: <span className="font-medium">{lane.lane}</span>,
        children: (
          <div className="flex flex-col gap-6">
            {lane.prices.map((price) => (
              <section key={price.key}>
                <h3 className="mb-2 text-sm font-medium text-fg">
                  {price.jobTypeCode} · {price.cargo} · <span className="text-muted">{RATE_BASIS_LABELS[price.basis]}</span>
                </h3>
                <PriceVersionsTable lines={price.lines} today={today} canEdit={canEdit} onChangePrice={onChangePrice} onShowHistory={onShowHistory} />
              </section>
            ))}
          </div>
        ),
      }))}
    />
  );
}
